import { oneTimeTokenClientIdQueryKeys, oneTimeTokenRefreshClientIds } from './constants.js';

export const getOneTimeTokenClientId = (
  searchParams: URLSearchParams,
  sessionAppId?: string
): string | undefined => {
  for (const key of oneTimeTokenClientIdQueryKeys) {
    const value = searchParams.get(key);

    if (value) {
      return value;
    }
  }

  return sessionAppId;
};

export const canRefreshOneTimeToken = (
  clientId?: string,
  allowedClientIds: readonly string[] = oneTimeTokenRefreshClientIds
): boolean => Boolean(clientId && allowedClientIds.includes(clientId));
